import styled, { css } from 'styled-components'

import SubmitButton from '../../../../Form/SubmitButton'

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`

export const StyledTimeSpan = styled.span`
  font-weight: 700;
  font-size: 18px;
`

const CommonStyles = css`
  min-width: 152px;
  border-radius: 16px !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  text-transform: none !important;
`

export const StyledConfirmButton = styled(SubmitButton)`
  ${CommonStyles}
  ${props =>
    !props.isReached &&
    css`
      background-color: #c2c8d1 !important;
      &:hover {
        background-color: #c2c8d1 !important;
        filter: none !important;
      }
    `}
`

export const StyledCancelButton = styled(SubmitButton)`
  ${CommonStyles}
  background-color: #ffffff !important;
  color: #00112b !important;
  border: 1px solid #273754 !important;
`
